var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditSignatureWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Signature_Default_18px",
    transform: "translate(-528 -484)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_961",
    "data-name": "Rectangle 961",
    width: 18,
    height: 18,
    transform: "translate(528 484)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2854",
    "data-name": "Group 2854",
    transform: "translate(528.884 485.162)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M40.371,15.58H31.478a.754.754,0,1,0,0,1.5h8.893a.754.754,0,1,0,0-1.5Z",
    transform: "translate(-24.967 -1.265)",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M38.138,3.427l-11.4,11.42L25.79,16.7l1.846-.948,11.42-11.4-.928-.928ZM40.467,1.1l-.928.928.928.928.928-.928a.655.655,0,0,0,0-.928h0A.655.655,0,0,0,40.467,1.1Z",
    transform: "translate(-25.79 -0.905)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSignatureWhiteIcon);
export default __webpack_public_path__ + "static/media/edit-signature-white-icon.521fa6765589b0ab68bf3aed3988cc96.svg";
export { ForwardRef as ReactComponent };